import { useContext } from 'react';
import { incaAccessor } from '@cancercentrum/inca';
import { IncaContext } from '../components/ScopedIncaContext/IncaContext';
export const useIsFormReadOnly = ()=>{
    const ctx = useContext(IncaContext);
    return ctx?.form.isReadOnly ?? incaAccessor().form.isReadOnly;
};
